import { Injectable } from '@angular/core';
import { FormExtractorService } from 'src/app/modules/shared/services/form-extractor.service';
import { AttributionFromMAPA } from './models/AttributionFromMAPA';
import { FormmapaServices } from './services/formmapa-services/formmapa.service';
import { LogService } from 'src/app/modules/shared/services/log.service';
import { Avis } from 'src/app/models/avis';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { Annonce } from '../../common/models/annonce';
import { StatutAvisEnum } from '../../../../models/enums/statut-avis.enum';
import { MapaService } from '../common/services/mapa/mapa.service';
import { CommonService } from '../../common/services/common/common.service';
import { MAPA } from '../common/models/MAPA';
import { TypeAvisEnum } from '../../../../models/enums/type-avis.enum';
import { AvisDataTransferService } from '../../../shared/services/avis-data-transfer.service';
import { RadioCheckBoxEnum } from '../../common/radio.checkbox.enums';
import { StepperBuilderService } from '../../../avisDePub/creer/services/stepper.builder.service';

@Injectable({
  providedIn: 'root'
})
export class FormmapaATExtractorService {

  private LOG: LogService = new LogService(FormmapaATExtractorService);

  constructor(private formExtractorService: FormExtractorService, private formmapaServices: FormmapaServices,
    private mapaService: MapaService,
    private commonService: CommonService,
    private avisDataTransferService: AvisDataTransferService,
    private stepperBuilderService: StepperBuilderService) { }

  public mapFormToAvis(form: any, stepId, actualFormIdAnnEmetteur): Avis {

    const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
    const attributionFromMAPA = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.attributionFromMAPA;

    attributionFromMAPA.attribution = this.formmapaServices.attributionService.getAttribution(controls, this.formExtractorService, stepId);
    if(stepId == 1) {
      attributionFromMAPA.avisInitial = this.formmapaServices.avisInitialService.getAvisInitial(controls);
    }
    if(stepId == 7) {
      attributionFromMAPA.autresInformations = this.formmapaServices.autresInformationsService.getAutresInformations(controls, stepId);
    }
    if(stepId == 4) {
      attributionFromMAPA.criteresAttribution = this.formmapaServices.criteresAttributionService.getCriteresAttribution(controls, this.formExtractorService);
    }
    if(stepId == 3) {
      attributionFromMAPA.descriptionReduite = this.formmapaServices.descriptionReduiteService.getDescriptionReduite(controls, this.formExtractorService);
      attributionFromMAPA.autresInformations = this.formmapaServices.autresInformationsService.getAutresInformations(controls, stepId);
      attributionFromMAPA.resultatAttribution = controls.get('_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution_SepAtt_infructueux');
      if (attributionFromMAPA.resultatAttribution === RadioCheckBoxEnum.attribueUnique) {
        this.stepperBuilderService.addStepFieldsOnErrors('_STEP_ID_5', '_STEP_ID_5_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_TypeAdresseCompleteMorale_SepAtt_personneMorale', 'Le dénomination du titulaire est obligatoire si le marché est attribué.');
        this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_6');
      } else if (attributionFromMAPA.resultatAttribution === RadioCheckBoxEnum.attribueLots
                || attributionFromMAPA.resultatAttribution === RadioCheckBoxEnum.lotsInfructueux) {
        this.stepperBuilderService.addStepFieldsOnErrors('_STEP_ID_6', '_STEP_ID_6_SepSep_AttributionFromMAPA_SepSep_Attribution_index_1_SepSep_LotMarche_SepAtt_numLot', 'L\'identifiant du lot est obligatoire.');
        this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_5');
      } else {
        this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_5');
        this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_6');
      }
    }
    attributionFromMAPA.procedure = this.formmapaServices.procedureService.getProcedure(controls);
    attributionFromMAPA.pasAvisInitial = controls.get('_SepSep_AttributionFromMAPA_SepAtt_pasAvisInitial');

    const mapa: MAPA = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa;
    if(stepId == 2) {
		  mapa.organisme = this.mapaService.organismeService.getOrganisme(controls);
    }
		mapa.initialFromMAPA = null;
		mapa.attributionFromMAPA = attributionFromMAPA;
		mapa.rectificatifFromMAPA = null;
    mapa.annulationFromMAPA = null;

    const annonce: Annonce = new Annonce();
		annonce.ann.idAnnEmetteur = actualFormIdAnnEmetteur;
    annonce.ann.divers = null;
		annonce.ann.mapa = mapa;
		annonce.ann.fnSimple = null;
		annonce.ann.formAD = null;
    annonce.ann.facturation = this.commonService.facturationService.getFacturation(form, 'DIV', controls);
    annonce.ann.indexation = this.commonService.indexationService.getIndexation(form);
    annonce.ann.dateEnvoi = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepAtt_dateEnvoi');

    annonce.annonceur.login = controls.get('_SepSep_idAnnonceur_SepAtt_idannonceurboampweb');
		annonce.annonceur.mail = controls.get('_SepSep_idAnnonceur_SepAtt_mailcontactboampweb');

    const avis: Avis = new Avis();

    avis.jsonSaisieFormulaire = annonce;
    avis.formulaire.code = FormsEnum[FormsEnum.MAPA_AT];
    avis.statut = StatutAvisEnum.ELABORE;
    avis.critere.typeAvis.code=TypeAvisEnum.C4_3;

    // TODO
    avis.jsonSaisieFormulaire.ann.mapa.attributionFromMAPA.procedure.procedureAdaptee =  '' ;
    return avis;
  }
}
